import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as types from '@orgmap/store/types';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            userList: types.ORG_USER_SELECT,
        }),
    },
})
export default class OrgchartToolbar extends Vue {
    @Prop({ type: Object }) value!: any;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    selectedUsersCount: any = 0;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    userList!: orgmap.TUser[];

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    @Watch('userList')
    changedUserList() {
        this.selectedUsersCount = this.userList.length;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.selectedUsersCount = this.userList.length;
    }
}
